import * as React from "react";
import { connect } from "react-redux";
import ExpiryReturns from "../../screens/ExpiryReturns";

import {
  fetchExpiryReturns,
  pageSelected,
  ExpiryReturnview,
  itempageSelected,
  pdfExpiryReturnFullData,
  returnaccept,
  returnrejected,
  returnacceptOne,
  returnrejectedOne,
  updatePurchaseOrderTotals,
} from "./action";

class ExpiryReturnsContainer extends React.Component {
  render() {
    return (
      <ExpiryReturns
        fetchExpiryReturns={this.props.fetchExpiryReturns}
        ExpiryReturnsDetails={this.props.ExpiryReturnsDetails}
        ExpiryReturnsCount={this.props.ExpiryReturnsCount}
        pageSelected={this.props.pageSelected}
        ExpiryReturnview={this.props.ExpiryReturnview}
        ExpiryReturnDtls={this.props.ExpiryReturnDtls}
        ItemCount={this.props.ItemCount}
        itempageSelected={this.props.itempageSelected}
        pdfreturnFullData={this.props.pdfExpiryReturnFullData}
        returnaccept={this.props.returnaccept}
        returnrejected={this.props.returnrejected}
        returnacceptOne={this.props.returnacceptOne}
        returnrejectedOne={this.props.returnrejectedOne}
        updatePurchaseOrderTotals={this.props.updatePurchaseOrderTotals}
      />
    );
  }
}

function bindAction(dispatch) {
  return {
    fetchExpiryReturns: (value) => dispatch(fetchExpiryReturns(value)),

    pageSelected: (value) => dispatch(pageSelected(value)),

    ExpiryReturnview: (value) => dispatch(ExpiryReturnview(value)),

    itempageSelected: (value) => dispatch(itempageSelected(value)),

    pdfExpiryReturnFullData: (value) => dispatch(pdfExpiryReturnFullData(value)),

    returnaccept: (value) => dispatch(returnaccept(value)),

    returnrejected: (value) => dispatch(returnrejected(value)),

    returnacceptOne: (value) => dispatch(returnacceptOne(value)),

    returnrejectedOne: (value) => dispatch(returnrejectedOne(value)),

    updatePurchaseOrderTotals: (value) =>
      dispatch(updatePurchaseOrderTotals(value)),
  };
}

const mapStateToProps = (state) => ({
  ExpiryReturnsDetails: state.ExpiryReturnsReducer.ExpiryReturnsDetails,

  ExpiryReturnsCount: state.ExpiryReturnsReducer.ExpiryReturnsCount,

  ExpiryReturnDtls: state.ExpiryReturnsReducer.ExpiryReturnDtls,

  ItemCount: state.ExpiryReturnsReducer.ItemCount,
});

export default connect(mapStateToProps, bindAction)(ExpiryReturnsContainer);
